module.exports = __webpack_public_path__ + "img/uni_heidelberg-1.8d17beb7.jpg";